export const allFacilities = ({ coachFacilities, academies }) => {
  // flatten the facilities and academies into one array
  const facilities = coachFacilities.concat(
    academies.map(academy => {
      return academy.facilities
    }),
  )
  return facilities.flat()
}
